import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Modal, Paper, Button, Tooltip } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import "components/pages/transmissions/modal/billing/BillingModal.css";
import LoadingSpinner from "components/LoadingSpinner";
import {
  toggleModal,
  toggleProcessing,
} from "app/store/transmission/slice/transmissionSlice";
import { useBillReportsMutation } from "app/store/transmission/api/transmissionTableApi";

import { showErrorToast, showSuccessToast } from "utils/toast";

const BillingModal = ({ setRowSelection }) => {
  const { totalSelectedRows, selectedReports, isBillingModal, isProcessing } =
    useSelector((state) => state.transmission);

  const [billReports] = useBillReportsMutation();
  const dispatch = useDispatch();

  const onConfirm = async () => {
    try {
      dispatch(toggleProcessing(true));
      const response = await billReports(selectedReports).unwrap();

      if (!response?.error) {
        showSuccessToast(response?.message);
      }
    } catch (error) {
      showErrorToast(error?.message);
    } finally {
      setRowSelection?.({});
      dispatch(toggleProcessing(false));
      dispatch(toggleModal({ type: "billing", value: false }));
    }
  };

  const onClose = () => {
    dispatch(toggleProcessing(false));
    dispatch(toggleModal({ type: "billing", value: false }));
  };

  return (
    <div>
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={isBillingModal}
        onClose={onClose}
      >
        <div className="process-modal__container">
          <Paper>
            <div className="process-modal__wrapper">
              <Tooltip title="Close" placement="bottom">
                <div onClick={onClose} className="process-modal__close">
                  <CloseIcon />
                </div>
              </Tooltip>
              <div className="process-modal__text">
                {!isProcessing && (
                  <div>
                    {totalSelectedRows === 1 && (
                      <div>Are you sure you want to bill this record?</div>
                    )}
                    {totalSelectedRows > 1 && (
                      <div>
                        Are you sure you want to bill these {totalSelectedRows}{" "}
                        records?
                      </div>
                    )}
                  </div>
                )}
                {isProcessing && (
                  <div>
                    <div className="process-modal__processing">
                      Billing {totalSelectedRows}{" "}
                      {totalSelectedRows > 1 ? "reports" : "report"}.
                    </div>
                    <div className="process-modal__spinner">
                      <LoadingSpinner color="secondary" />
                    </div>
                  </div>
                )}
              </div>
              <div className="process-modal__buttons">
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={onConfirm}
                  disabled={isProcessing}
                >
                  Bill
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={onClose}
                  disabled={isProcessing}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </Paper>
        </div>
      </Modal>
    </div>
  );
};

export default BillingModal;
